import { DateInput } from '@blueprintjs/datetime';
import { Classes } from '@blueprintjs/core';
import moment from 'moment';
import React, { ChangeEvent, useEffect, useMemo, useState } from 'react'
import { RELATIVE_DAYS_OPERATORS } from '../types';

type FilterDayInputProps = {
  operator: string,
  defaultFilledValue: any,
  onChange: any,
}

const FilterDayInput = ({ defaultFilledValue, operator, onChange }: FilterDayInputProps) => {
  const [filledValue, setFilledValue] = useState<any>(defaultFilledValue)

  const handleFilledData = (value: Date | string) => {
    setFilledValue(value)
    onChange(value)
  }

  const isRelative = useMemo(() => {
    return RELATIVE_DAYS_OPERATORS.includes(operator)
  }, [operator])

  useEffect(() => {
    const isValueValidDate = moment(defaultFilledValue, 'DD/MM/YYYY', true).isValid()
    if (isRelative) {
      if (defaultFilledValue && !isValueValidDate) {
        handleFilledData(defaultFilledValue)
      } else {
        handleFilledData('1')
      }
    } else {
      if (defaultFilledValue && isValueValidDate) {
        handleFilledData(defaultFilledValue)
      } else {
        handleFilledData(moment().format('DD/MM/YYYY'))
      }
    }
  }, [isRelative])


  return <div onClick={(evt) => {
    evt.stopPropagation();
  }}>
    {isRelative ? (
      <div className='days-ago-input-container'>
        <input
          autoFocus
          className={`${Classes.INPUT} style-input`}
          defaultValue={1}
          type="number"
          value={filledValue}
          onChange={(event) => handleFilledData(event.target.value)}
          min={1}
        />
        <div>
          days ago
        </div>
      </div>
    ) : (
      <DateInput
        formatDate={(date) => moment(date).format('DD/MM/YYYY')}
        parseDate={(str) => moment(str, 'DD/MM/YYYY').toDate()}
        value={filledValue ? moment(filledValue, 'DD/MM/YYYY').toDate() : new Date()}
        className="custom-radio-button__dateinput"
        popoverProps={{
          usePortal: false,
        }}
        onChange={(date) => handleFilledData(moment(date).format('DD/MM/YYYY'))}
        highlightCurrentDay
      />
    )}
  </div>
}

export default FilterDayInput
